import React from "react";

import { FormField, FormLabel } from "@impero-com/ui";
import { Typography } from "antd";

import * as theme from "./InputWithRightText.theme.css";

const { Text } = Typography;

interface InputWithRightTextProps {
    label: string;
    children: React.ReactNode;
    rightText: string;
}
// This is a bad composition - we're double-wrapping inputs with FormField
// Which is terrible, because we're duplicating styles - there's 2 max-widths &
// because the component tree will be semantically wrong - Parent > FormField > InputAbstraction > FormField > antd.Input
// It is already used in 4+ places - if you need to compose other inputs, please consider refactoring the input to support composition
export const InputWithRightText = ({
    label,
    children,
    rightText,
}: InputWithRightTextProps) => {
    return (
        <FormField>
            <FormLabel>{label}</FormLabel>
            <div className={theme.inputWithText}>
                {children}
                <Text>{rightText}</Text>
            </div>
        </FormField>
    );
};
